import { Link } from "react-router";
import { Heading2 } from "~/components/ui/Heading";
import { PageTitle } from "~/components/ui/PageTitle";
import { useRealm, useT } from "~/util/Lang";
import { MetaFunc, OurLoaderArgs } from "~/util/Loaders";
import { logPageView } from "~/util/stats";
import { homePage } from "~/util/titles";

export const loader = async (args: OurLoaderArgs) => {
  // Log
  logPageView(args);
  //
  return { authUser: args.req.sess?.user };
};

export const meta: MetaFunc<{}> = (cx) => {
  return {
    title: `${cx.t({ en: "About", ru: "О нас" })} - ${homePage(cx.realm)}`,
  };
};

export default function About() {
  const t = useT();
  const realm = useRealm();

  const title = t({
    en: "About",
    ru: "О нас",
  });
  return (
    <div className="content">
      <PageTitle>{title}</PageTitle>
      <div className="columns">
        <div className="column is-three-quarters">
          <Heading2>{t({ ru: "Важно!", en: "Important!" })}</Heading2>
          <ul>
            <li>
              {t({
                ru: "Это фан-страница. Сервис используется исключительно в информационных целях.",
                en: "This is a fanpage. The use of the service is for informational purposes only.",
              })}
            </li>
            <li>
              {t({
                ru: "Вы можете ознакомиться с оригинальной версией игры Lineage 2 на официальных серверах NCsoft.",
                en: "You can familiarize yourself with the original version of the game Lineage 2 on the official servers of NCSoft.",
              })}
            </li>
          </ul>
          <Heading2>
            {t({ en: "Data sources", ru: "Источники данных" })}
          </Heading2>
          <Data />
        </div>
        <div className="column"></div>
      </div>
    </div>
  );
}

function Team() {
  return (
    <div className="columns">
      <div className="column">
        <div>pvolok - папкин бродяга, мамкин симпотяга</div>
        <div>discord @pvolok</div>
      </div>
      <div className="column">
        <div>djoctuk - чувачог</div>
        <div>discord @djoctuk</div>
      </div>
    </div>
  );
}

function Data() {
  const t = useT();
  return (
    <ul>
      <li style={{ marginBottom: 7, fontSize: 14 }}>
        <Link to="/c1">L2Hub C1: Harbingers of War</Link> -{" "}
        {t({
          ru: "Использует данные PTS Сервера Chronicle 1: Harbingers of War и Клиента Chronicle 1: Harbingers of War",
          en: "Uses PTS data from the Chronicle 1: Harbingers of War Server and the Chronicle 1: Harbingers of War Client",
        })}
      </li>
      <li style={{ marginBottom: 7, fontSize: 14 }}>
        <Link to="/c2">L2Hub C2: Age of Splendor</Link> -{" "}
        {t({
          ru: "Использует часть данных PTS Сервера Chronicle 4: Scions of Destiny и Клиента Chronicle 2: Age of Splendor, данные по дропу-спойлу взяты с",
          en: "Uses PTS data from the Chronicle 4: Scions of Destiny Server and the Chronicle 2: Age of Splendor Client, and the drop-spoil data is from the",
        })}{" "}
        <a href="https://knowledgedb.elmorelab.com/" target="_blank">
          {t({
            en: "Knowledge Database ElmoreLab",
            ru: "Базы знаний сервера ElmoreLab",
          })}
        </a>
      </li>
      <li style={{ marginBottom: 7, fontSize: 14 }}>
        <Link to="/c3">L2Hub C3: Rise of Darkness</Link> -{" "}
        {t({
          ru: "Использует часть данных PTS Сервера Chronicle 4: Scions of Destiny и Клиента Chronicle 3: Rise of Darkness, данные по дропу-спойлу взяты с",
          en: "Uses PTS data from the Chronicle 4: Scions of Destiny Server and the Chronicle 3: Rise of Darkness Client, and the drop-spoil data is from the",
        })}{" "}
        <a href="https://knowledgedb.elmorelab.com/" target="_blank">
          {t({
            en: "Knowledge Database ElmoreLab",
            ru: "Базы знаний сервера ElmoreLab",
          })}
        </a>
      </li>
      <li style={{ marginBottom: 7, fontSize: 14 }}>
        <Link to="/">L2Hub GF: Gracia Final</Link> -{" "}
        {t({
          ru: "Использует данные PTS Сервера The 2nd Throne: Gracia Final и Клиента The 2nd Throne: Gracia Final",
          en: "Uses PTS data from the The 2nd Throne: Gracia Final Server and the The 2nd Throne: Gracia Final Client",
        })}
      </li>
    </ul>
  );
}
